<div
  class="container-fluid video-container"
  [class.video-container--bg]="!!backgroundImage || !!backgroundColor"
  [class.video-container--centered]="centered && !!backgroundImage"
  [style.background-image]="backgroundImage ? 'url(' + backgroundImage + ')' : null"
  [style.background-color]="backgroundColor || null"
>
  <div class="container px-1">
    <!--
      From md up, `alignImageBlock` picks the side the image sits on. Below that
      the two columns stack, and the order is always image -> title ->
      description -> button, so the image column is ordered first and both
      columns fall back to DOM order (`order-md-0`) once the row kicks in.
    -->
    <div
      class="d-flex flex-wrap justify-content-between align-items-center"
      [class]="alignImageBlock == 'left' ? 'flex-row-reverse' : 'flex-row'"
    >
      <div
        id="block-title"
        class="col-md-6 px-0 row flex-column justify-content-start align-self-stretch order-2 order-md-0"
      >
        <div class="col-auto">
          <!-- Skeleton -->
          <ng-container *ngIf="loading">
            <div class="skeleton skeleton--title"></div>
            <div class="skeleton skeleton--text skeleton--line-80"></div>
            <div class="skeleton skeleton--text"></div>
            <div class="skeleton skeleton--text skeleton--line-60"></div>
          </ng-container>

          <!-- Content -->
          <ng-container *ngIf="!loading">
            <div class="px-0 ">
              <h5
                *ngIf="title"
                class="titleTextFont"
                [style.text-align]="alignTextBlock ? alignTextBlock : 'left'"
                [style.color]="titlesColor"
                [style.font-size]="'40px'"
                [style.font-weight]="'800'"
                [style.margin-bottom]="'0px'"
                [innerHTML]="title | safeHtml"
              ></h5>
            </div>
            <div
              *ngIf="subtitleText"
              class="px-0 mt-3 mb-2 subtitle-block rich-text"
              [style.text-align]="alignTextBlock ? alignTextBlock : 'left'"
              [style.color]="secondaryColor"
              [innerHTML]="subtitleText | safeHtml"
            ></div>
          </ng-container>
        </div>

        <div class="col-auto">
          <div
            class="d-flex flex-wrap mt-4 mb-3 mt-md-3 mb-md-0 align-left"
            *ngIf="!loading && (btn1Active || btn2Active)"
          >
            <a
              *ngIf="btn1Active"
              [href]="btn1Link"
              class="btn btn-info btn-flex mr-3 mt-md-0 mt-2 col-auto list-btn "
              (click)="onBtn1Click($event)"
            >
              {{ btn1Text }}
              <i class="fa fa-arrow-right mx-2"></i>
            </a>
            <a
              *ngIf="btn2Active"
              [href]="btn2Link"
              class="btn btn-info btn-flex mr-2 mt-md-0 mt-2 col-auto"
              (click)="onBtn2Click($event)"
            >
              {{ btn2Text }}
              <i class="fa fa-arrow-right mx-2"></i>
            </a>
          </div>
        </div>
      </div>
      <div
        class="block-image col-md-6 col-12 px-0 d-flex justify-content-center order-1 order-md-0"
      >
        <div
          class="thumbContainer hover-shadow img-fluid container-height col px-0 ml-md-5"
          style="margin-bottom: 0"
        >
          <div *ngIf="loading" class="skeleton skeleton--image"></div>
          <img
            *ngIf="!loading"
            alt="Video thumbnail"
            [src]="thumbnail"
            onError="this.src='assets/images/placeholder.svg'"
            loading="lazy"
            decoding="async"
          />
          <div class="playContainer" *ngIf="!loading && type === 'video'">
            <img
              alt="Play button"
              class="playButton"
              [src]="playButton"
              loading="lazy"
              decoding="async"
              height="45"
              width="45"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
